// extracted by extract-css-chunks-webpack-plugin
module.exports = {"empty-state":"OrderHelpTemplateEmptyState-94c6be20fabe878d","empty-state-text-wrapper":"OrderHelpTemplateEmptyState-4c1935d70a9c1647"};